import type { CommentableContentObject, Reply } from 'models';
import type { RefObject } from 'react';
import type { RichTextMentions } from 'ui';
import { Comment } from '../comment';
import { CommentList } from '../comment-list';

type P = {
  canComment: boolean;
  canDeleteComment: (comment: Reply) => boolean;
  comment: Reply;
  contentObjectId: string;
  contentObjectType: CommentableContentObject['type'];
  onRequestMentions: RichTextMentions;
  scrollRef?: RefObject<HTMLDivElement | null>;
  scrollToReplyId?: string;
  topParentShareableId?: string;
};

const CommentThread = ({
  canComment,
  canDeleteComment,
  comment,
  contentObjectId,
  contentObjectType,
  onRequestMentions,
  scrollRef,
  scrollToReplyId,
  topParentShareableId,
}: P) => (
  <>
    <Comment
      canComment={canComment}
      canDeleteComment={canDeleteComment}
      comment={comment}
      contentObjectId={contentObjectId}
      contentObjectType={contentObjectType}
      onRequestMentions={onRequestMentions}
      scrollRef={scrollRef}
      topParentShareableId={topParentShareableId}
    />
    {comment.replies && comment.replies.length > 0 ? (
      <CommentList
        canComment={canComment}
        canDeleteComment={canDeleteComment}
        comments={comment.replies}
        contentObjectId={contentObjectId}
        contentObjectType={contentObjectType}
        nested
        onRequestMentions={onRequestMentions}
        scrollToReplyId={scrollToReplyId}
        topParentShareableId={topParentShareableId}
      />
    ) : null}
  </>
);

export default CommentThread;
